// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5bB9r3DL8qdvXFwudvI-QBUUWtHQQwck",
  authDomain: "coqueteria-b7812.firebaseapp.com",
  projectId: "coqueteria-b7812",
  storageBucket: "coqueteria-b7812.appspot.com",
  messagingSenderId: "989667520249",
  appId: "1:989667520249:web:88612288f63522a199fc28",
  measurementId: "G-DFVLM11833"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export default function getFirestoreApp() {
    return app
}